import { render } from "./Balanta.vue?vue&type=template&id=345d1a8d&scoped=true&ts=true"
import script from "./Balanta.ts?vue&type=script&lang=ts"
export * from "./Balanta.ts?vue&type=script&lang=ts"

import "./Balanta.vue?vue&type=style&index=0&id=345d1a8d&scoped=true&lang=scss"

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345d1a8d"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QCard,QList,QItem,QItemSection,QItemLabel});
